var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11196_25264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6595 15.6667L9.99284 19M9.99284 19L13.3262 15.6667M9.99284 19V11.5",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9919 15.323C17.8047 14.8798 18.4467 14.1787 18.8168 13.3301C19.1868 12.4816 19.2637 11.534 19.0354 10.6369C18.807 9.73974 18.2865 8.94421 17.5558 8.37582C16.8251 7.80744 15.9259 7.49856 15.0002 7.49795H13.9502C13.698 6.52232 13.2278 5.61656 12.5752 4.84878C11.9225 4.08099 11.1042 3.47116 10.182 3.06512C9.25967 2.65909 8.25734 2.46742 7.25031 2.50452C6.24328 2.54162 5.25777 2.80654 4.36786 3.27934C3.47795 3.75214 2.7068 4.42054 2.1124 5.23427C1.51799 6.048 1.11579 6.9859 0.936028 7.97745C0.756269 8.969 0.803632 9.98839 1.07456 10.959C1.34548 11.9296 1.83291 12.8262 2.50021 13.5813",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11196_25264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.13db34f8472a1eed47476c47677bc9f2.svg";
export { ForwardRef as ReactComponent };